<template>
  <div class="driverDetail">
    <!-- <el-drawer
      size="50%"
      title="设置二级地块"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <basic-container> -->
    <div class="group-title">基本信息</div>
    <div style="display: flex; " class="group-form">
      <label for="plots" style="white-space: nowrap">新增地块：</label>

      <div class="tags" style="margin: 20px 0px">
        <el-tag
          v-for="(tag, index) in tags"
          :key="index"
          closable
          @close="handleClose(index)"
          style="margin-right: 6px;margin-bottom: 6px;"
        >
          {{ tag }}
        </el-tag>
        <!-- <el-input
          id="plots"
          v-model.trim="plotsName"
          style="width: 300px"
          maxlength="15"
          size="small"
          placeholder="请输入地块名称"
        >
         
        </el-input> -->
        <el-button type="primary"
            plain
            class="add-tag" @click="openDialog" size="small" 
            >新增地块</el-button
          >
       
      </div>
    </div>
       <div class="tip">新增地块以后，APP端显示此项为必填项</div>

    <div class="btns" style="text-align: center; margin-top: 20px">
      <!-- <el-button @click="cancelModal" size="small" style="margin-left: 20px">取 消</el-button> -->
      <el-button
        type="primary"
        size="small"
        :loading="btnLoading"
        @click="handleUpdate"
        >保存</el-button
      >
    </div>
    <el-dialog
      width="548px"
      :close-on-click-modal="false"
      v-if="tagVisible"
      :visible.sync="tagVisible"
    >
      <template slot="title">
        <div class="check-title">
          <i class="el-icon-info" style="color: #35b1ff; margin-right: 8px"></i>
          添加地块
        </div>
      </template>
      <div class="dialog-content">
        <el-input
          v-model="plotsName"
          placeholder="请输入地块名称"
        ></el-input>
        <div class="err-tip">{{ tagErrTxt }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tagVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTag">保存</el-button>
      </div>
    </el-dialog>
    <!-- </basic-container>
    </el-drawer> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getMemberList,
  getProjectList,
  editLandParcel,
} from "@/api/chain/projectinfo";
export default {
  props:['info'],
  data() {
    return {
      tagVisible:false,
      tagErrTxt:"",
      btnLoading: false,
      plotsName: "",
      tags: [],
      // info: {},
    };
  },
  created() {},
  mounted() {
    // this.info = JSON.parse(this.$route.query.info);
    // debugger
    let tmp = this.info.landParcel;
    this.tags = tmp ? tmp.split(",") : [];
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    openDialog(){
      this.plotsName=""
      this.tagVisible=true
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
    addTag() {
      if (!this.plotsName) return false;
      if (this.tags.includes(this.plotsName)) {
        this.tagErrTxt="已有相同的地块名称"
        // this.$message.error("地块名称已存在");
      } else {
        this.tags.push(this.plotsName);
        this.tagVisible=false
      }
    },
    handleClose(index) {
      this.tags.splice(index, 1);
    },
    handleUpdate() {
      this.btnLoading = true;
      editLandParcel({
        projectInfoId: this.info.id,
        landParcel: this.tags,
      })
        .then((res) => {
          this.btnLoading = false;
          this.$message.success("保存成功")
          // this.$emit("update:visible", false);
          // this.$emit("getPage");
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

/deep/ .el-drawer__header {
  margin-bottom: 10px;
}
.driverDetail {
  position: relative;
  height: calc(100vh - 300px);
  margin-left: 20px;
  margin-top: 20px;
}
.btns {
  position: absolute;
  left: 0;
  right: 0;
  padding-top: 8px;
  bottom: -12px;
  border-top: 1px solid #ededf0;
}
.group-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  margin-bottom: 16px;
}
.group-form {
  margin-left: 68px;
  label {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
.tip {
  margin-left: 68px;
  padding: 8px 16px;
  background: #ededf0;
  font-weight: 400;
  font-size: 12px;
  color: #939399;
  width: 254px;
  margin-top: 14px;
}
.dialog-content {
  margin-left: 30px;
  .err-tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    color: #e60026;
  }
  /deep/.el-input--medium .el-input__inner {
    height: 48px;
    line-height: 48px;
  }
}
/deep/.el-dialog__footer {
  background: #fff;
  justify-content: flex-end;
  margin-right: 20px;
}
/deep/.tags{
  margin: 0!important;
}

</style>
